import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: ""
};
import { reactive, ref } from 'vue';
import Title from '../title/index.vue';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'Lyric'
  },
  __name: 'lyric',
  setup(__props, {
    expose: __expose
  }) {
    const tags = ['rock', 'punk', 'jazz', 'soul', 'country', 'kidsmusic', 'pop'];
    const showCustom = ref(false);
    const formData = reactive({
      lyric: '',
      style: '',
      name: '',
      version: ''
    });
    __expose({
      formData
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_space = _resolveComponent("el-space");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Title, {
        title: "歌词",
        desc: "自己编写歌词或使用Ai生成歌词，两节/8行效果最佳"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: formData.lyric,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.lyric = $event),
          autosize: {
            minRows: 6,
            maxRows: 6
          },
          resize: "none",
          type: "textarea",
          maxlength: "1200",
          "show-word-limit": "",
          placeholder: "请输入您自己的歌词"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(Title, {
        title: "音乐风格"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_space, {
          class: "flex-wrap"
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tags, tag => {
            return _createVNode(_component_el_tag, {
              key: tag,
              round: "",
              class: "mb-8px"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(tag), 1)]),
              _: 2
            }, 1024);
          }), 64))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: showCustom.value ? 'primary' : 'default',
          round: "",
          size: "small",
          class: "mb-6px",
          onClick: _cache[1] || (_cache[1] = () => {
            showCustom.value = !showCustom.value;
          })
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("自定义风格 ")])),
          _: 1
        }, 8, ["type"])]),
        _: 1
      }), _withDirectives(_createVNode(Title, {
        desc: "描述您想要的音乐风格，Suno无法识别艺术家的名字，但可以理解流派和氛围",
        class: "-mt-12px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: formData.style,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.style = $event),
          autosize: {
            minRows: 4,
            maxRows: 4
          },
          resize: "none",
          type: "textarea",
          maxlength: "256",
          "show-word-limit": "",
          placeholder: "输入音乐风格(英文)"
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 512), [[_vShow, showCustom.value]]), _createVNode(Title, {
        title: "音乐/歌曲名称"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: formData.name,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.name = $event),
          placeholder: "请输入音乐/歌曲名称"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(Title, {
        title: "版本"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: formData.version,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.version = $event),
          placeholder: "请选择"
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([{
            value: '3',
            label: 'V3'
          }, {
            value: '2',
            label: 'V2'
          }], item => {
            return _createVNode(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]);
    };
  }
});